export default {
  id: null,
  name: null,
  description: null,
  key: null,
  url: null,
  isInternal: false,
};
